import { Navbar } from "../shared/components/Navbar.tsx"
import { DashedLine } from "../shared/components/DashedLine.tsx"
import { useLanguage } from "../shared/context/LanguageContext.tsx";

export function TermsConditions() {
    const { translation } = useLanguage();

    const termsConditionsContent = [
        {
            title: translation.TermsConditions1,
            description: translation.TermsConditionsDesc1,
        },
        {
            title: translation.TermsConditions2,
            description: translation.TermsConditionsDesc2,
        },
        {
            title: translation.TermsConditions3,
            description: translation.TermsConditionsDesc3,
        },
        {
            title: translation.TermsConditions4,
            description: translation.TermsConditionsDesc4,
        },
        {
            title: translation.TermsConditions5,
            description: translation.TermsConditionsDesc5,
        },
        {
            title: translation.TermsConditions6,
            description: translation.TermsConditionsDesc6,
        },
        {
            title: translation.TermsConditions7,
            description: translation.TermsConditionsDesc7,
        },
        {
            title: translation.TermsConditions8,
            description: translation.TermsConditionsDesc8,
        },
        {
            title: translation.TermsConditions9,
            description: translation.TermsConditionsDesc9,
        },
        {
            title: translation.TermsConditions10,
            description: translation.TermsConditionsDesc10,
        },
        {
            title: translation.TermsConditions11,
            description: translation.TermsConditionsDesc11,
        },
        {
            title: translation.TermsConditions12,
            description: translation.TermsConditionsDesc12,
        },
        {
            title: translation.TermsConditions13,
            description: translation.TermsConditionsDesc13,
        },
        {
            title: translation.TermsConditions14,
            description: translation.TermsConditionsDesc14,
        },
        {
            title: translation.TermsConditions15,
            description: translation.TermsConditionsDesc15,
        },
        {
            title: translation.TermsConditions16,
            description: translation.TermsConditionsDesc16,
        },
    ]
    
    return (
        <main>
            <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
                <Navbar />
            </div>
            <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:flex-row lg:gap-20 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
                <div className="min-w-[25%] text-[1.75rem] md:text-3xl lg:text-[2.5rem] font-bold px-5 pt-9 lg:px-0 lg:pt-0 text-primary !leading-[130%]">{translation.termsAndConditions}</div>
                <div className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem] px-5 lg:px-0 pb-[1.875rem] ld:pb-0 text-base md:text-lg lg:text-[1.375rem]">
                    {termsConditionsContent.map((item, index) => (
                        <div key={index} className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem]">
                            <div className="flex flex-col gap-2.5">
                                <div className="text-base font-bold md:text-lg lg:text-[1.375rem] text-primary whitespace-pre-line">
                                    {item.title}
                                </div>
                                {Array.isArray(item.description) ? item.description.map((desc, i) => (
                                    (item.title === translation.TermsConditions6 && typeof desc !== 'object' && i === 0) || (item.title === translation.TermsConditions7 && typeof desc !== 'object' && i === 0)
                                    || (item.title === translation.TermsConditions8 && typeof desc !== 'object' && (i === 0 || i === 1|| i === item.description.length - 1)) ||
                                    (item.title === translation.TermsConditions13 && typeof desc !== 'object' && (i === 0 || i === 1)) ? (
                                        <div key={i} className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black">
                                            {desc}
                                        </div>
                                    ) : 
                                    item.title === translation.TermsConditions6 && typeof desc === 'object' ? (
                                        <div key={i} className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black">
                                            <span className="font-medium">{desc.bold}</span> {desc.description}
                                        </div>
                                    ) : typeof desc === "string" ? (
                                        <li key={i} className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black ms-6 md:ms-7 lg:ms-8">
                                            {desc}
                                        </li>
                                    ) : <></>
                                )) : (
                                    <div className="text-base font-normal md:text-lg lg:text-[1.375rem] text-black whitespace-pre-line">
                                        {item.description}
                                    </div>
                                )}
                            </div>
                            {index !== termsConditionsContent.length - 1 && <DashedLine key={index} />}
                        </div>
                    ))}
                </div>
            </div>
        </main>
    )
}